module.exports = __webpack_public_path__ + "static/ig logo-7e1a85be75fb5f1babbdc96fbba93608.png";